/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
function isAdminRole() {
    const role = JSON.parse(localStorage.getItem('role') || 'null')
    const roleName = role && typeof role === 'object' ? role.name : role
    return roleName === 'admin' || roleName === 'super-admin'
}

export default [
    {
        path: '/statistiques',
        name: 'Statistiques',
        component: () => import('@/views/Statistics/StatisticsDashboard.vue'),
        meta: { permission: 'company.statistics' }
    },
    {
        path: '/statistiques/config',
        name: 'StatisticsConfig',
        component: () => import('@/views/Statistics/StatisticsConfig.vue'),
        meta: { permission: 'company.statistics' },
        beforeEnter(to, from, next) {
            if (isAdminRole()) next()
            else next({ name: 'Page403' })
        }
    }
]
